import { createAsyncThunk } from '@reduxjs/toolkit';

export const changeRound = createAsyncThunk(
    'statspro/changeRound',
    async (options = {}, { dispatch }) => {
        const { slice, round, season } = options;

        // Set nav ready state to false
        dispatch({ type: `statspro/${slice}/setReady`, payload: false });

        dispatch({
            type: `statspro/${slice}/setNavItem`,
            payload: {
                navItem: 'round',
                value: round
            }
        });

        // If not whole season, set benchmarking and datatype to default
        if (round.id !== -1) {
            dispatch({
                type: `statspro/${slice}/setBenchmarking`,
                payload: {
                    isActive: false
                }
            });

            dispatch({
                type: `statspro/${slice}/setDataType`,
                payload: {
                    type: 'totals'
                }
            });
        }

        // If season has changed, trigger ready when new round matches
        // season we have changed to.
        if (season.id) {
            if (season.id === round.seasonId) {
                dispatch({
                    type: `statspro/${slice}/setReady`,
                    payload: true
                });
            }
        } else {
            dispatch({
                type: `statspro/${slice}/setReady`,
                payload: true
            });
        }
    }
);
